import React from 'react'
import { withTranslationCustom } from 'lib/i18next'

const FormElementErrorMessage = ({ t, message }) => (
    <span className="validation-message validation-message--error">{message.indexOf('text:') === 0 ? message : t(message)}</span>
)

export default withTranslationCustom('formElements')(FormElementErrorMessage)
